import React from "react"
import { Icon, Popup } from "semantic-ui-react"

const BifrostWaringIcon = ({ content }) => {
	return <Popup content={content} wide="very" trigger={<Icon name="warning circle" style={{ color: "#2e3d59" }} />} />
}

BifrostWaringIcon.propTypes = {}

export default BifrostWaringIcon
